import { useMemo } from "react";
import moment from "moment";

const useProductData = (fetchData) => {
  // Ensure `data` is always an array
  const data = Array.isArray(fetchData) ? fetchData : [];

  const formattedData = useMemo(() => {
    const rows = [];

    data.forEach((item, index) => {
      rows.push({
        id: index + 1 || "",
        role_id: item.role_id || "",
        name: item.name || "",
        status: item.status || "",
        created_date: item.created_date
          ? moment(item.created_date).format("DD/MM/YYYY\n เวลา HH:mm:ss น.")
          : "",
        updated_date: item.updated_date
          ? moment(item.updated_date).format("DD/MM/YYYY\n เวลา HH:mm:ss น.")
          : "",
      });
    });

    return rows;
  }, [data]);

  return formattedData;
};

export default useProductData;
